import * as React from 'react';
import { useSelector } from 'react-redux';
import { AerialViewModal } from '../../components/AerialViewModal';
import { CallMeBackContainer } from '../CallMeBack';
import {
  getFirstBuilder,
  getHasOffersFromDeveloper,
  getNewbuildingDisplayName,
  getPriceForMeterFromDeveloperDisplay,
  getPriceForObjectFromDeveloperDisplay,
} from '../../selectors/newbuilding';
import { ActionButtonContainer } from '../ActionButton';
import { getDescriptionText } from './helpers/getDescriptionText';

interface IAerialViewModalContainerProps {
  isOpen: boolean;
  source: string;
  onClose(): void;
}

export const AerialViewModalContainer: React.FC<IAerialViewModalContainerProps> = ({ isOpen, source, onClose }) => {
  const priceForObjectFromDeveloperDisplay = useSelector(getPriceForObjectFromDeveloperDisplay);
  const priceForMeterFromDeveloperDisplay = useSelector(getPriceForMeterFromDeveloperDisplay);
  const newbuildingName = useSelector(getNewbuildingDisplayName);
  const { name: builderName } = useSelector(getFirstBuilder) || {};
  const hasOffersFromDeveloper = useSelector(getHasOffersFromDeveloper);
  const description = getDescriptionText({ builderName, hasOffersFromDeveloper });

  return (
    <AerialViewModal
      isOpen={isOpen}
      source={source}
      newbuildingName={newbuildingName}
      description={description}
      onClose={onClose}
      priceForMeterFromDeveloperDisplay={priceForMeterFromDeveloperDisplay}
      priceForObjectFromDeveloperDisplay={priceForObjectFromDeveloperDisplay}
      callbackButton={<CallMeBackContainer placeType="airphoto" />}
      contactsButton={
        <ActionButtonContainer
          dynamicCalltrackingPlaceType="virtualLandTourModalWindow"
          analyticOnOpenActionName="Open_airphoto"
          fullWidth
          XXL
        />
      }
    />
  );
};
